<template>
    <b-container>
        <b-card-group deck>
            <AppCard v-for="app in apps" :key="app.system" :app="app" />
        </b-card-group>
    </b-container>
</template>

<script>
    import AppCard from './card'
    export default {
        data() {
            return {
                apps: [
                    {
                        system: 'Linux',
                        method: 'Package',
                        instructions:
                            'Go to the official website for instructions to your distro.'
                    },
                    {
                        system: 'macOS',
                        method: 'App Store',
                        instructions: 'Search for WireGuard on the App Store.',
                        alternative: '.app',
                        alternativeLink: 'wireguard.app.zip'
                    },
                    {
                        system: 'Windows',
                        method: 'Installer',
                        instructions: 'Download from the official website.',
                        alternative: 'installer',
                        alternativeLink: 'wireguard.msi'
                    },
                    {
                        system: 'Android',
                        method: 'Play Store',
                        instructions: 'Search for WireGuard on the Play Store.',
                        link:
                            'https://play.google.com/store/apps/details?id=com.wireguard.android',
                        alternative: 'APK',
                        alternativeLink: 'wireguard.apk'
                    },
                    {
                        system: 'iOS',
                        method: 'App Store',
                        instructions: 'Search for WireGuard on the App Store.'
                    },
                    {
                        system: 'ChromeOS',
                        method: 'Play Store',
                        instructions: 'Search for WireGuard on the Play Store.',
                        link:
                            'https://play.google.com/store/apps/details?id=com.wireguard.android',
                        alternative: 'APK',
                        alternativeLink: 'wireguard.apk'
                    }
                ]
            }
        },
        components: {
            AppCard
        }
    }
</script>